import { render, staticRenderFns } from "./index.vue?vue&type=template&id=266cdf2a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266cdf2a')) {
      api.createRecord('266cdf2a', component.options)
    } else {
      api.reload('266cdf2a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=266cdf2a&", function () {
      api.rerender('266cdf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/saleer/index.vue"
export default component.exports